import { DRXNavContent as DRXNavContentME } from "./medexpress";
import { DRXNavContent as DRXNavContentZH } from "./ziphealth";

export default {
  ["medexpress"]: DRXNavContentME,
  ["ziphealth"]: DRXNavContentZH,
};
